module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Medium.woff
// module id = 1574
// module chunks = 57